import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from '../../../login/login.service';
import { ValuacionService } from '../valuacion.service';

@Component({
  selector: 'app-catalogo-valuacion-moneda-extranjera',
  templateUrl: './catalogo-valuacion-moneda-extranjera.component.html',
  styleUrls: ['./catalogo-valuacion-moneda-extranjera.component.css'],
  preserveWhitespaces: true
})
export class CatalogoValuacionMonedaExtranjeraComponent implements OnInit {
  cargado: boolean;
  items: any[] = [];
  monedas: any[] = [];
  busqueda: any = {};
  totalItems: number;
  rotate: any;
  constructor(public loginService: LoginService, public service: ValuacionService) { }

  ngOnInit(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
    this.cargarMonedas();
  }
  cargarMonedas() {
    this.service.monedas(this.loginService.empresa as number).subscribe(
      response => {
        this.monedas = response.contenido;
      }
    );
  }
  cargarCatalogo() {
  this.cargado = false;
    this.mostrarMensajeCarga();
    this.busqueda.criteriaSearch['emp'] = this.loginService.empresa;
    this.service.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        this.totalItems = response.contenido.totalElements;
          this.cerrarMensajeCarga();
          console.log(response);
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }

  eliminar(dtoDelete: any): void {
    Swal.fire({
      title: 'Eliminar',
      text: `¿Está seguro de eliminar este elemento?`,
      showCancelButton: true,
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this.service.delete(dtoDelete.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          Swal.fire('TNK Ledger', err.error.mensaje, 'error');
        });
      }
    });
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
   this.cargarCatalogo();
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }

  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
